module.exports = __webpack_public_path__ + "static/q17_o-89804f5ea5c0db5f5d71e6bd0185a475.png";